class Guid {
	static validator = new RegExp(
		'^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$',
		'i',
	);
	static EMPTY = '00000000-0000-0000-0000-000000000000';
	value: string;

	static isGuid = (value: string | Guid) => {
		return (
			value &&
			(value instanceof Guid || Guid.validator.test(value.toString()))
		);
	};

	static gen = (count: number): string => {
		let out = '';
		for (let i = 0; i < count; i++) {
			out += (((1 + Math.random()) * 0x10000) | 0)
				.toString(16)
				.substring(1);
		}
		return out;
	};

	static create = () => {
		return new Guid(
			[
				Guid.gen(2),
				Guid.gen(1),
				Guid.gen(1),
				Guid.gen(1),
				Guid.gen(3),
			].join('-'),
		);
	};

	static isLittleEndian = () => {
		const buffer = new ArrayBuffer(4);
		const uint32Array = new Uint32Array(buffer);
		const uint8Array = new Uint8Array(buffer);
		uint32Array[0] = 0x01020304;
		return uint8Array[0] === 0x04;
	};

	static createVersion1WithTime = () => {
		// Начало Григорианского календаря в миллисекундах с 1 января 1970 года
		const GregorianCalendarStart = new Date(
			Date.UTC(1582, 9, 15),
		).getTime();

		// Имитация "MAC-адреса" случайным образом
		const macAddressBytes = new Uint8Array(6);
		crypto.getRandomValues(macAddressBytes);

		// Генерация случайных байтов для clock sequence
		const clockBytes = new Uint8Array(2);
		crypto.getRandomValues(clockBytes);

		// Вычисление текущего времени с начала Григорианского календаря
		const now = BigInt(Date.now() - GregorianCalendarStart) * 10000n;

		// Преобразование времени в байты
		const timeBytes = new Uint8Array(8);
		for (let i = 0; i < 8; i++) {
			timeBytes[7 - i] = Number((now >> BigInt(i * 8)) & 0xffn);
		}

		if (Guid.isLittleEndian()) {
			clockBytes.reverse();
			timeBytes.reverse();
		}

		// Формирование UUID
		const result = new Uint8Array(16);
		result.set(timeBytes.slice(0, 4).reverse(), 0);
		result.set(timeBytes.slice(4, 6).reverse(), 4);
		result.set(timeBytes.slice(6, 8).reverse(), 6);
		result.set(clockBytes, 8);
		result.set(macAddressBytes, 10);

		// Установка версии
		result[6] &= 0x1f;
		result[6] |= 0x10;

		// Установка варианта
		result[8] &= 0xbf;
		result[8] |= 0x80;

		return new Guid(
			Array.from(result)
				.map((b) => {
					return b.toString(16).padStart(2, '0');
				})
				.join('')
				.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/g, '$1-$2-$3-$4-$5'),
		);
	};

	static raw = () => {
		return [
			Guid.gen(2),
			Guid.gen(1),
			Guid.gen(1),
			Guid.gen(1),
			Guid.gen(3),
		].join('-');
	};

	static Parse = (strValue: string) => {
		return new Guid(strValue);
	};

	constructor(guid: string | Guid) {
		if (!guid) {
			throw new TypeError('Invalid argument; `value` has no value.');
		}
		this.value = Guid.EMPTY;

		if (guid && guid instanceof Guid) {
			this.value = guid.toString();
		} else if (
			guid &&
			Object.prototype.toString.call(guid) === '[object String]' &&
			Guid.isGuid(guid)
		) {
			this.value = guid.toString();
		}
	}

	equals = (other: string) => {
		///<summary>Comparing string `value` against provided `guid` will auto-call
		/// toString on `guid` for comparison</summary>
		return Guid.isGuid(other) && this.value === other;
	};

	isEmpty = () => {
		return this.value === Guid.EMPTY;
	};

	toString = () => {
		return this.value;
	};

	toJSON = () => {
		return this.value;
	};
}

export default Guid;
